module.exports = __webpack_public_path__ + "static/media/exchange.24b47295.png";